import { LEAD_ACCEPTANCE, APPOINTMENTS } from '_constants';
import { fetchContact } from '../services/referrals.services';
import { fetchOpportunityByContactId } from '../services/opportunities.services';
import { fetchAppointment, fetchCalendars } from '../services/appointments.services';
import { AcceptAutoAssignedLead, fetchAutoAssignedContact, fetchAutoAssignedOpportunitiy } from '../services/autoassignment.services';
import { updateAppointment } from './appointments.actions';
import { redirectToRoute } from 'actions';
import { APPOINTMENT_STATUS, APPOINTMENT_DISPOSITIONS, REASSIGNED_MESSAGE } from '../constants';
import { isResponseSuccess } from 'helpers';
import { showServerResponse, throwError, customModalActions } from './modals.actions';
import _ from 'lodash';

const fetch = (contactId, opportunityId, appointmentId, isAutoAssignment, routeTo = '') => async (dispatch, getState) => {
  const { appointments = {} } = getState();
  if (!appointments.calendar) {
    const calendarResponse = await dispatch(fetchCalendars());
    if (isResponseSuccess(calendarResponse)) {
      const calendar = _.isArray(calendarResponse.data) && calendarResponse.data.length > 0 && calendarResponse.data[0];
      dispatch({ type: APPOINTMENTS.UPDATE_CALENDAR, calendar: calendar });
    }
  }

  function getContactDetails () {
    if (isAutoAssignment) {
      return dispatch(fetchAutoAssignedContact(contactId, 'Addresses,EmailAddresses,Groups,Notes,PhoneNumbers,Assignment,LeadSources'));
    } else {
      return dispatch(fetchContact(contactId, 'Addresses,EmailAddresses,Groups,Notes,PhoneNumbers,Assignment,LeadSources'));
    }
  }

  function getOpportunityDetails () {
    if (isAutoAssignment) {
      return dispatch(fetchAutoAssignedOpportunitiy(contactId, opportunityId));
    } else {
      return dispatch(fetchOpportunityByContactId(contactId, opportunityId));
    }
  }
  try {
    const contactDetails = getContactDetails();
    const opportunityDetails = getOpportunityDetails();
    const appointmentDetails = dispatch(fetchAppointment(appointmentId));
    const responses = await Promise.all([contactDetails, opportunityDetails, appointmentDetails]);
    const data = [];
    responses.forEach(res => {
      if (!isResponseSuccess(res)) { return responses; }
      data.push(res.data);
    });
    dispatch({ type: LEAD_ACCEPTANCE.ACTION.UPDATE_LEAD_ACCEPTANCE, value: data });
    return responses;
  } catch (err) {
    dispatch(displayError(err, routeTo));
    return Promise.reject(err);
  }
};

const acceptAppointment = (appointment) => async (dispatch, getState) => {
  try {
    const response = await dispatch(updateAppointment(appointment, APPOINTMENT_STATUS.ACCEPTED.id, APPOINTMENT_DISPOSITIONS.AGENT_ACCEPTED_LEAD_AND_APPOINTMENT));
    dispatch(showServerResponse(response, 'Accepted Lead', 'Erorr Accepting Lead'));
    dispatch({ type: LEAD_ACCEPTANCE.ACTION.ACCEPTED_LEAD });
    return response;
  } catch (err) {
    if (err.response.status === 403) {
      dispatch(throwError('goback', REASSIGNED_MESSAGE));
    } else {
      dispatch(throwError('goback'));
    }
    return Promise.reject(err);
  }
};

const acceptAutoAssignedLead = (acceptLeadDetails, routeTo) => async (dispatch, getState) => {
  try {
    const response = await dispatch(AcceptAutoAssignedLead(acceptLeadDetails));
    dispatch(showServerResponse(response, 'Accepted Lead', 'Erorr Accepting Lead'));
    dispatch({ type: LEAD_ACCEPTANCE.ACTION.ACCEPTED_LEAD });
    return response;
  } catch (err) {
    dispatch(displayError(err, routeTo));
    return Promise.reject(err);
  }
};

const displayError = (error, redirectToRoute) => async (dispatch, getState) => {
  if (error.response.status === 403 || error.response.status === 409) {
    dispatch(showErrorMessage(redirectToRoute, error.response.data.message));
  } else {
    dispatch(throwError('goback'));
  }
};

const showErrorMessage = (redirection = '', errorMessage) => (dispatch) => {
  dispatch(customModalActions.updateCustomModal(true, null, errorMessage, null, null, null, null, null, null, null, null, 'error-modal'));
  setTimeout(() => {
    if (redirection) { dispatch(redirectToRoute(redirection)); }
    dispatch(customModalActions.updateCustomModal(false));
  }, 3000);
};

export const leadAcceptanceActions = {
  fetch,
  acceptAppointment,
  acceptAutoAssignedLead,
  showErrorMessage
};
